import { ReactComponent as OutlineChevronDown16 } from "assets/svg/outline-chevron-down-16.svg";
import { ReactComponent as OutlineChevronUp16 } from "assets/svg/outline-chevron-up-16.svg";
import IconButton from "components/icon-button";
import TimezoneDropdown from "components/timezone-dropdown/TimezoneDropdown";
import styles from "./ScrollableCalendarViewHeader.module.scss";
import DayLabel from "./components/DayLabel";
import FullDayEventSlot from "./components/FullDayEventSlot";
import useScrollableCalendarViewHeader from "./useScrollableCalendarViewHeader";

type Props = {
  datesForWeek: {
    [x: string]: Date;
  };
  today: Date;
};

/**
 * renders a scrollable calendar view header
 */
const ScrollableCalendarViewHeader = ({ datesForWeek, today }: Props) => {
  const {
    timezone,
    setTimezone,
    expanded,
    setExpanded,
    showExpandToggle,
    fullDayEventSlots,
    isWeeklyView,
    handleDayLabelClick,
  } = useScrollableCalendarViewHeader(datesForWeek);

  return (
    <table className={styles["scrollable-calendar-view-header"]}>
      <thead>
        <tr className={styles["date"]}>
          <th
            className={styles["timezone"]}
            rowSpan={fullDayEventSlots.length + 1}
          >
            <div className={styles["timezone__content"]}>
              {/* timezone selector */}
              <TimezoneDropdown
                value={timezone}
                onApply={setTimezone}
                className={styles["timezone__dropdown"]}
              />
              {/* full day events expand toggle */}
              {showExpandToggle && (
                <IconButton
                  className={styles["expand-toggle"]}
                  onClick={() => setExpanded((s) => !s)}
                >
                  {expanded ? <OutlineChevronUp16 /> : <OutlineChevronDown16 />}
                </IconButton>
              )}
            </div>
          </th>

          {Object.entries(datesForWeek).map(([dayOfWeek, date]) => (
            <DayLabel
              key={dayOfWeek}
              date={date}
              timezone={timezone}
              today={today}
              dayOfWeek={dayOfWeek}
              isWeeklyView={isWeeklyView}
              handleDayLabelClick={handleDayLabelClick}
            />
          ))}
        </tr>

        {fullDayEventSlots.map((row, i) => (
          <tr key={i}>
            {row.map((item, j) => (
              <FullDayEventSlot
                key={`${i}-${j}`}
                item={item}
                onExpandClick={() => setExpanded(true)}
              />
            ))}
          </tr>
        ))}
      </thead>
    </table>
  );
};

export default ScrollableCalendarViewHeader;
